// extracted by mini-css-extract-plugin
export var active = "_5r-1";
export var activeSubdued = "_5r-2";
export var compact = "_5r-3";
export var pulse = "_5r-4";
export var settingHighlightPulse = "_5r-5";
export var wrapper = "_5r-0";